import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';


export class EncryptionHandler {

  public static encryptToAES256(text: string) {
    let key = CryptoJS.enc.Utf8.parse(environment.secretPassphrase);
    let iv = CryptoJS.lib.WordArray.random(16);
    let value = CryptoJS.enc.Utf8.parse(text);

    let encrypted = CryptoJS.AES.encrypt(value, key, {
      keySize: 16,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return `${iv.toString()}.${encrypted.toString()}`;
  }

  public static decryptToAES256(ciphertext: string) {
    let [iv, encrypted] = ciphertext.split('.');
    let ivBuffer = CryptoJS.enc.Hex.parse(iv);
    let key = CryptoJS.enc.Utf8.parse(environment.secretPassphrase);

    let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      keySize: 16,
      iv: ivBuffer,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
